import React from "react";
import * as classNames from "classnames";
import styles from "./list.css";

import { Divider, TextDivider } from "../divider/divider";

export const List = ({ children, className }) => {
	const allClassNames = classNames(styles.list, className);

	return <ul className={allClassNames}>{children}</ul>;
};

export const ListItem = ({ children, className }) => {
	const allClassNames = classNames(styles.listItem, className);

	return <li className={allClassNames}>{children}</li>;
};

export const ListItemLink = ({ children, className, href }) => {
	const allClassNames = classNames(
		styles.listItem,
		styles.listItemLink,
		className,
	);

	return (
		<li className={allClassNames}>
			<a href={href}>{children}</a>
		</li>
	);
};

export const ListItemButton = ({ children, className, onClick }) => {
	const allClassNames = classNames(
		styles.listItem,
		styles.listItemButton,
		className,
	);

	return (
		<li className={allClassNames}>
			<button className={styles.buttonReset} onClick={onClick}>
				{children}
			</button>
		</li>
	);
};

export const ListItemDivider = ({ children }) => {
	const allClassNames = classNames(styles.listItem, styles.listItemDivider);

	return (
		<li className={allClassNames}>
			<Divider />
		</li>
	);
};

export const ListItemTextDivider = ({ children, text }) => {
	const allClassNames = classNames(styles.listItem, styles.listItemTextDivider);

	return (
		<li className={allClassNames}>
			<TextDivider text={text} />
		</li>
	);
};



// WEBPACK FOOTER //
// ./src/components/ui/list/list.js